import { ObservableMap } from '@stencil/store';

import { defaultServiceOrder } from '../constants/defaultServiceOrder';
import { Account } from '../models/account';
import { Service } from '../models/service';
import { isMsiOrStandalone } from '../utils/EnvironmentUtil';
import { caseInsensitiveCompare } from '../utils/helper';
import Logger from '../utils/logger/logger';
import { getMenuConfig } from '../utils/menu';
import { defaultActiveItems } from './defaultState';
import { State } from './types/state';

export function setActiveLogoUrl(store: ObservableMap<State>, account: Account, theme: string) {
    const lightLogo = account?.organization?.lightLogo ?? '';
    const darkLogo = account?.organization?.darkLogo ?? lightLogo;

    store.set('activeLogoUrl', theme === 'dark' ? darkLogo : lightLogo);
}

export function setMenuItems(store: ObservableMap<State>) {
    const isHostMode = store.get('isHost');
    const account = store.get('account');

    const menuConfig = getMenuConfig(store);
    let menuItems: Service[] = [];

    if (isHostMode) {
        Logger.info('store', 'setting menu items for host');
        menuItems = menuConfig.services.filter(service => !!service.showInHostAccount);
        store.set('menuItems', menuItems);
        return;
    }

    Logger.debug('store', 'setting menu items for cloud');

    const serviceOrder: string[] = [ ...defaultServiceOrder ];
    Logger.debug('store', 'service order', { object: serviceOrder });

    const accountServices = account?.organization?.accountServices ?? defaultActiveItems;
    Logger.debug('store', 'account level services', { object: accountServices });

    const tenant = store.get('currentTenantInfo');
    Logger.debug('store', 'used for menu items', { object: tenant });

    const enabledServices = tenant?.enabledServices ?? [];
    const activeItems = (isMsiOrStandalone(store)) ? store.get('overrideServices') : enabledServices.concat(accountServices);
    const activeServices = serviceOrder.filter(service => activeItems.includes(service));

    activeServices.forEach((activeService) => {
        const service = menuConfig.services.find(menuConfigService => caseInsensitiveCompare(menuConfigService.id, activeService));
        if (service) {
            menuItems.push(service);
        }
    });

    store.set('menuItems', menuItems);
}

export function isFalselyOrWhiteSpace(str: string | null | undefined = '') {
    return !str || !str.trim();
}
